import SearchOrCreateSelectInput from "../../core/inputs/SearchOrCreateSelectInput";


function getVendorObjectLabel(vendor) {
    return <>
        <span><strong>{vendor.name}</strong></span>
        {vendor.labels && vendor.labels.length !== 0 && <><br></br><span className="select-label-secondary-level">{vendor.labels.map((label) => label.name).join(", ")}</span></>}
    </>
}

function vendorToVendorOption(vendor) {
    return {value: vendor.id, label: getVendorObjectLabel(vendor), object: vendor}
}

function VendorSearchOrCreateSelect(props) {
    const { listEndpointKwargs: propsKwargs, ...restProps } = props;

    const defaultEndpointKwargs = [
        ["is_active", true],
    ]

    // Merge default kwargs with any passed from props
    const endpointKwargs = [
        ...defaultEndpointKwargs,
        ...(propsKwargs || [])
    ]

    return <SearchOrCreateSelectInput
        objectName="Vendor"
        getObjectLabel={getVendorObjectLabel}
        listEndpoint={DjangoUrls["pricebook:api-vendors-lightweight-list"](window.MARKETPLACE_ENTITY_SLUG)}
        listEndpointKwargs={endpointKwargs}
        getDetailsEndpoint={(vendor) => DjangoUrls["pricebook:api-vendors-detail"](window.MARKETPLACE_ENTITY_SLUG, vendor.id)}
        {...restProps}
    />
}

export { vendorToVendorOption };
export default VendorSearchOrCreateSelect
